namespace $.$$ {
	export class $shm_hitalama_map_touch_selection extends $.$shm_hitalama_map_touch_selection {
		point_x() { return this.point()[0] + 'px' }
		point_y() { return this.point()[1] + 'px' }
		label_left() { return `clamp(8px, ${ this.point()[0] - 120 }px, calc(100% - 248px))` }
		label_top() { return Math.max(8, this.point()[1] - 80) + 'px' }
		label_views() { return this.moving() ? [] : [ this.Label() ] }
	}
}
